import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '../components/Button';
import { toast } from 'sonner';
import { CheckCheck } from 'lucide-react';
import { Para } from 'components/Para';
import { Heading } from 'components/Heading';
import { appConfig } from 'engine/appConfig';

export const Route = createFileRoute('/')({
	component: Index,
});

function Index() {
	return (
		<div className="p-2">
			<Heading>{appConfig.title} Console</Heading>
			<Para>here are some links:</Para>
			<div className="flex flex-col gap-3 rounded-md border border-red-500 bg-red-300 p-4 text-red-950">
				<Link to="/">Home</Link> <Link to="/login">Login</Link>
				<Link to="/test">Message test</Link>
			</div>

			<Button
				onClick={() => {
					toast('Hello world', {
						// cspell:disable
						description: 'lorem ipsum dolor sit amet...',
						// cspell:enable
						icon: <CheckCheck />,
					});
				}}
			>
				Show toast
			</Button>
		</div>
	);
}
